import { useMemo } from 'react';

import { useIsDeleteUserEnabled } from '../../featureChecks';
import type { UseMainUIFeatureSettings } from '../../types';
import { uiFeatureAccessSymbol } from '../../types';

/**
 * @deprecated `@ms/yammer-web-ui-features` is a monolithic package which adds bloat from all feature access settings
 * to a single bootstrap API call (FeatureAccessSettingsClients) and JS assets. DO NOT add new code to this package.
 * Your team is responsible for migrating fields and code out of this package as you move your features to Relay, where
 * your feature should request the necessary `viewerCanXX` fields in its own colocated fragment. Note that we may also
 * need to design a new scalable permissions-check solution for features which require additional logic to check access.
 */
export const useRemoveUserSectionSettings: UseMainUIFeatureSettings<'removeUserSection'> = (options) => {
  const removeUserSectionOverrides = options?.overrides?.removeUserSection;

  const viewerCanRemoveUser = useIsDeleteUserEnabled();

  return useMemo(
    () => ({
      [uiFeatureAccessSymbol]: viewerCanRemoveUser,
      ...removeUserSectionOverrides,
    }),
    [removeUserSectionOverrides, viewerCanRemoveUser]
  );
};
